import Image from "next/legacy/image";
import Link from "next/link";
import RightArrowIcon from "../components/common/icons/RightArrowIcon";

import NoTextNavBackground from "../components/common/NoTextNavBackground";
import HeroSlider from "../components/common/slider/HeroSlider";
import { blurDataURL, kotokoEleven } from "../utils/constants/images";
import { FABU_CENSUS_URL, POLL_LIST_URL } from "../utils/constants/websiteUrls";
import { customStaticSeoConfig } from "../utils/helpers/helpers";
import { FaPoll } from "react-icons/fa";
import {
  AppStoreButton,
  PlayStoreButton,
} from "../components/common/buttons/AppStoreButtons";

import {
  fans1,
  fans2,
  fans3,
  fans4,
  fans5,
  artBoard,
} from "../utils/constants/images";

const Fans = () => {
  const images = [fans1, fans2, fans3, fans4, fans5];

  const title = "Football is nothing without fans";
  const seoTitle = "Asante Kotoko Fans";
  const caption =
    "Get the latest news and info about Asante Kotoko fans, including Supporters' Clubs and #ILOVEKOTOKO fan parties. ";

  return (
    <>
      {customStaticSeoConfig(seoTitle)}

      <NoTextNavBackground />

      <HeroSlider title={title} gallery={images} showScrollToRead={true} />

      <div className="mt-10 max-w-2xl mx-auto lg:max-w-6xl lg:px-8 px-6">
        {/* SLIDER */}
        <div>
          <p className="text-2xl">
            Get involved and become part of the Kotoko family. It has never been
            so easy to be connected with your club.
          </p>

          <p className="text-base mt-4">
            Here are some of the best ways you can get involved with your club
            and feel part of Asante Kotoko.
          </p>
        </div>

        {/* FABU CENSUS */}
        <div className="block max-w-sm gap-3 mx-auto sm:max-w-full group lg:grid lg:grid-cols-12 bg-gray-900 rounded-md mt-14">
          <div className="object-cover w-full h-64 sm:h-96 lg:col-span-7 bg-gray-500 relative rounded-md rounded-bl-none sm:rounded-bl-md rounded-br-none md:rounded-tr-md md:rounded-br-none md:rounded-bl-none lg:rounded-bl-md lg:rounded-tr-none">
            <Image
              src={fans4}
              alt="Thumbnail"
              layout="fill"
              objectFit="cover"
              placeholder="blur"
              blurDataURL={blurDataURL}
              quality={100}
              className="rounded-md rounded-bl-none sm:rounded-bl-md rounded-br-none sm:rounded-tr-none md:rounded-tr-md md:rounded-bl-none md:rounded-br-none lg:rounded-bl-md lg:rounded-tr-none"
            />
          </div>

          <div className="flex flex-col justify-center flex-1 p-6 space-y-6 lg:col-span-5">
            <span className="text-xs uppercase text-gray-400">
              {"Fabu Census - Join, it's free"}
            </span>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-100">
              {"Become part of the Asante Kotoko family"}
            </h3>
            <p className="my-6 text-gray-400">
              {
                "Take your support to the next level by becoming an official member of the club, get priority access to match tickets, unlock exclusive member benefits, as well as a host of other benefits."
              }
            </p>
            <Link
              href={FABU_CENSUS_URL}
              role="button"
              className="self-start px-4 py-3 text-base font-medium rounded-md bg-red-600 hover:bg-red-900 dark:bg-green-800 dark:hover:bg-green-900 text-gray-100 "
              target="blank"
              rel="noopener noreferrer"
            >
              {"Become a member"}
            </Link>
          </div>
        </div>

        {/* KOTOKO APP */}
        <div className="text-gray-50 py-14">
          <div className="grid grid-cols-12 mx-auto bg-gray-900 rounded-md">
            <div
              className="bg-no-repeat bg-cover  col-span-full lg:col-span-4 rounded-tr-md rounded-br-md"
              style={{
                backgroundImage: `url(${kotokoEleven})`,
                backgroundPosition: "center center",
                backgroundBlendMode: "multiply",
                backgroundSize: "contain",
              }}
            ></div>
            <div className="flex flex-col p-6 col-span-full row-span-full lg:col-span-8 lg:p-10">
              <h1 className="text-2xl sm:text-3xl font-bold">
                Download the Asante Kotoko App
              </h1>
              <p className="flex-1 pt-6 pb-6 text-gray-400">
                Download the Asante Kotoko app today and join millions of fans
                around the world. Never miss a moment. Get access to the
                greatest club on the planet from the palm of your hands.
                Download the app and register now for exclusive access
              </p>
              <div className="max-w-md mx-auto flex flex-col items-center space-y-6 sm:space-y-0 sm:space-x-6 sm:flex sm:flex-row sm:justify-center">
                <PlayStoreButton />
                <AppStoreButton />
              </div>
            </div>
          </div>
        </div>

        {/* POLLS */}
        {/* <section className="bg-gray-900 text-gray-100 py-14 rounded-md mb-10">
        <div className="container flex flex-col mx-auto lg:flex-row">
          <div
            className="w-full lg:w-1/3"
            style={{
              backgroundImage: `url(${fans5})`,
              backgroundPosition: "center center",
              backgroundBlendMode: "multiply",
              backgroundSize: "cover",
            }}
          ></div>
          <div className="flex flex-col w-full p-6 lg:w-2/3 md:p-8 lg:p-12">
            <FaPoll className="w-8 h-8 mb-8 text-red-400 dark:text-green-400" />
            <h2 className="text-3xl font-semibold leading-none">
              Let your opinions be heard
            </h2>
            <p className="mt-4 mb-8 text-sm text-gray-400">
              Partake in decision making from man of the match, player of the
              month, goal of the month, player of the season to goal to of the
              season and much more...
            </p>
            <Link
              href={POLL_LIST_URL}
              className="inline-flex items-center pt-6 pb-6 space-x-2 text-sm text-red-400 hover:text-red-600 dark:text-green-400 dark:hover:text-green-600">

              <span>Vote now</span>
              <RightArrowIcon />

            </Link>
          </div>
        </div>
      </section> */}
      </div>
    </>
  );
};

export default Fans;
